import './AgWidgetContainer.scss';
import { ReactNode } from 'react';
import classNames from 'classnames';

interface AgWidgetContainerProps {
    children: ReactNode;
    className: string;
    gridRows: number;
    gridColumns: number;
}

export function AgWidgetContainer({
    children,
    className,
    gridRows,
    gridColumns,
}: AgWidgetContainerProps) {
    return (
        <div
            style={{
                // minmax is the fix to prevent the grid children from blowing out in size
                '--grid-template-columns': gridColumns,
                '--grid-template-rows': gridRows,
            }}
            className={classNames('AgWidgetContainer', className)}
        >
            {children}
        </div>
    );
}
